/**
 * SbForm - Wrapper around Ant Design Form
 * 
 * Provides a consistent form component across the application.
 * Centralizes form behavior, validation, and styling.
 * 
 * @example
 * import { SbForm } from 'uiCore';
 * 
 * const [form] = SbForm.useForm();
 * 
 * <SbForm form={form} onFinish={handleSubmit}>
 *   <SbForm.Item name="username" label="Username">
 *     <Input />
 *   </SbForm.Item>
 * </SbForm>
 */

import { Form } from 'antd';

const SbForm = Form;

// Re-export all Form sub-components and utilities
SbForm.Item = Form.Item;
SbForm.List = Form.List;
SbForm.ErrorList = Form.ErrorList;
SbForm.Provider = Form.Provider;
SbForm.useForm = Form.useForm;
SbForm.useFormInstance = Form.useFormInstance;
SbForm.useWatch = Form.useWatch;

export default SbForm;
